module.exports = "<section class=\"hero is-fullheight is-dark\">\r\n  <app-header></app-header>\r\n    <router-outlet style=\"display:none;\"></router-outlet>  \r\n  <app-footer></app-footer>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/dev/github/ng4wedding/wedding/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main